export const MATCH_SUGGESTION_STATUS_DEFERRED = 'deferred_phase_b'

export const QA_NAME_MATCH_SUGGESTION = 'matchSuggestion'

export const QA_NAME_MATCH_SUGGESTION_ACCEPT = 'matchSuggestionAccept'

export const QA_NAME_MATCH_SUGGESTION_DISMISS = 'matchSuggestionDismiss'
